import { EthAddress } from '@xylabs/sdk-js'
import { getApiStage } from '@xylabs/sdk-react'
import { XyoWorldEntitySettingsClient } from '@xyo-network/sdk-xyoworld-js'

class XyoWorldAuthenticatedEntity {
  public address: EthAddress
  public admin?: boolean
  constructor(address: EthAddress) {
    this.address = address
  }

  public async fetchAdmin(authToken?: string | null) {
    const entity = await XyoWorldEntitySettingsClient.get(this.address, authToken, getApiStage())
    return (this.admin = entity.data._admin)
  }

  public async getAdmin(authToken?: string | null) {
    return this.admin ?? (await this.fetchAdmin(authToken))
  }

  public async load(authToken?: string | null) {
    await this.getAdmin(authToken)
  }
}

export default XyoWorldAuthenticatedEntity
